import React, { useState, useEffect } from "react";

import { isEmpty } from "ramda";

import {
  Button,
  Pane,
  Typography,
  Steps,
  Input,
  Table,
  SearchBar,
} from "components/Common/clearsense-ui/components";
import { RightMinimalArrow } from "components/Common/clearsense-ui/icons";
import { useMetaIQDispatch, useMetaIQState } from "contexts/metaIQ";
import useDebounce from "hooks/useDebounce";

import { CATEGORIES, CATEGORIES_COLUMN } from "./constants";

const Category = ({ onClose, setStep }) => {
  const [categoryList, setCategoryList] = useState(CATEGORIES);
  const [classificationName, setClassificationName] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const { categories, databaseDetails } = useMetaIQState();
  const metaIQDispatch = useMetaIQDispatch();

  const debouncedSearchString = useDebounce(searchTerm, 1000);

  useEffect(() => {
    handleSearch(debouncedSearchString);
  }, [debouncedSearchString]);

  const handleSubmit = () => {
    metaIQDispatch({
      type: "SET_CATEGORY",
      payload: { categories: categoryList },
    });
    metaIQDispatch({
      type: "SET_DATABASE_DETAILS",
      payload: {
        databaseDetails: {
          ...databaseDetails,
          classification_name: classificationName,
        },
      },
    });
    setStep("database details");
  };

  const handleSearch = async term => {
    if (term.trim() === "") {
      setCategoryList(
        categoryList.map(category => ({ ...category, show: true }))
      );
    } else {
      setCategoryList(
        categoryList.map(category => {
          if (!category.label.toLowerCase().startsWith(term.toLowerCase())) {
            return { ...category, show: false };
          }

          return category;
        })
      );
    }
  };

  const handleSelect = selectedCategory => {
    setCategoryList(categories => {
      const newCategories = categories.filter(
        category => category.value !== selectedCategory.value
      );

      return [
        ...newCategories,
        { ...selectedCategory, selected: !selectedCategory.selected },
      ].sort((categoryA, categoryB) =>
        categoryA.value > categoryB.value ? 1 : -1
      );
    });
  };

  const filterCategories = () => categoryList.filter(category => category.show);

  useEffect(() => {
    if (!isEmpty(categories)) {
      setCategoryList(categories);
      setClassificationName(databaseDetails.classification_name);
    }
  }, []);

  return (
    <>
      <Pane.Body className="pt-2 pb-4">
        <Steps
          className="mb-6"
          currentStep={1}
          steps={[
            <Typography key="categories">Categories</Typography>,
            <Typography key="database_details">Database Details</Typography>,
            <Typography key="verify">Verify</Typography>,
          ]}
        />
        <div className="flex flex-col w-full space-y-4">
          <Input
            label="Add classification Name"
            placeholder="Enter a name for this classification"
            value={classificationName}
            onChange={e => setClassificationName(e.target.value)}
            required
          />
          <div className="flex-col space-y-2">
            <Typography>Search for a Category</Typography>
            <SearchBar
              placeholder="Search by category name"
              onChange={e => setSearchTerm(e.target.value)}
              style="secondary"
            />
          </div>
          <Table
            rowData={filterCategories()}
            columnData={CATEGORIES_COLUMN(handleSelect)}
            fixedHeight
            rowKey={record => record.id}
          />
        </div>
      </Pane.Body>
      <Pane.Footer>
        <div className="flex justify-between w-full ">
          <Button label="Cancel" style="secondary" onClick={onClose} />
          <Button
            label="Next"
            icon={RightMinimalArrow}
            iconPosition="right"
            onClick={handleSubmit}
            disabled={
              categoryList.filter(category => category.selected).length === 0 ||
              isEmpty(classificationName)
            }
          />
        </div>
      </Pane.Footer>
    </>
  );
};

export default Category;
